module.exports = "/images/GO.png?ee87a566529a2cffda04585ef540992c";